// extracted by mini-css-extract-plugin
module.exports = {"productImage":"styles__productImage--AF8jO","favoriteHeart":"styles__favoriteHeart--2kvAD","truncatedText":"styles__truncatedText--3sJ0f","success":"styles__success--1t6Eo"};